// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__3LOmQ","load7":"Spinner_load7__xND91"};